import {ReviewDecisionState} from '../types/list-types'

/**
 * Tooltip shown for a pull request that still requires review before it can merge.
 */
export const REVIEW_REQUIRED_TOOLTIP_LABEL = 'Review required before merging'

export interface ReviewDecisionCounts {
  approvedReviewsCount?: number
  changesRequestedReviewsCount?: number
}

/**
 * Builds the review-decision tooltip label for a pull request, matching the strings used by the
 * repository pulls list view (app/views/pull_requests/_pull_request_review_decision.html.erb):
 *
 * - Review required  → "Review required before merging"
 * - Approved         → "{n} review approval(s)", or "Approved" when the count is missing
 * - Changes requested → "{n} review(s) requesting changes", or "Changes requested" when the count is missing
 *
 * Returns `undefined` when there is no review decision to describe.
 */
export function reviewDecisionTooltipLabel(
  reviewDecisionState: ReviewDecisionState | undefined,
  {approvedReviewsCount, changesRequestedReviewsCount}: ReviewDecisionCounts = {},
): string | undefined {
  switch (reviewDecisionState) {
    case ReviewDecisionState.ReviewRequired:
      return REVIEW_REQUIRED_TOOLTIP_LABEL
    case ReviewDecisionState.Approved:
      return approvedReviewsCount && approvedReviewsCount > 0
        ? `${approvedReviewsCount} review approval${approvedReviewsCount === 1 ? '' : 's'}`
        : 'Approved'
    case ReviewDecisionState.ChangesRequested:
      return changesRequestedReviewsCount && changesRequestedReviewsCount > 0
        ? `${changesRequestedReviewsCount} review${changesRequestedReviewsCount === 1 ? '' : 's'} requesting changes`
        : 'Changes requested'
    default:
      return undefined
  }
}
